import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { AppFeatures } from 'src/app/core/app.features';
import { UserAccessLevel } from 'src/app/core/services/user.service';

export interface MenuItem {
  id?: number;
  title: string;
  icon?: IconProp;
  isHeader?: boolean;
  isDisplayedInShortMenu?: boolean;
  tab?: string;
  group?: string;
  link?: string | Array<string | number>;
  active?: boolean;
  user_access_level: UserAccessLevel;
  /** Feature application component gating the item (user.feature_components). */
  permission?: AppFeatures;
  /**
   * Access level that shows the item even without `permission`. Mirrors the
   * backend FeatureComponentGate shape: a feature component, or a minimum
   * access level without it.
   */
  permission_bypass_access_level?: UserAccessLevel;
  children?: Array<MenuItem>;
  expanded?: boolean;
}

export function filterMenuByAccessLevel(
  items: MenuItem[],
  level: UserAccessLevel,
  featureComponents?: Record<number, boolean>,
): MenuItem[] {
  return items
    .map((item) => {
      if (level < item.user_access_level) return null;
      if (item.permission && !featureComponents?.[item.permission]) {
        const bypass = item.permission_bypass_access_level;
        if (bypass === undefined || level < bypass) return null;
      }

      const children = item.children
        ? filterMenuByAccessLevel(item.children, level, featureComponents)
        : undefined;

      // If it had children and now it's empty -> drop it (category behaviour)
      if (item.children && children.length === 0) return null;

      return children ? { ...item, children } : item;
    })
    .filter((x): x is MenuItem => x !== null);
}
